import I2C from "i2c";
import {TextEncoder} from "encoding";
import sleep from "sleep";
import Bottleneck from "bottleneck";
import Device from "./device.js";
import Class from "class";


class EZO_I2C extends I2C {
  static constuctor() {
    Class.hook(EZO_I2C, Device);
  }
  constructor(...args) {    
    super(...args);

    this.limiter = new Bottleneck({
      maxConcurrent: 1,
      minTime: 10
    });      
  }
  async getFirmwareVersion() {
    var versionString = await this.command("i");
    versionString = versionString.split(",")[2];
    versionString += ".0";
    return versionString;
  }
  /* sending new command to the device while waiting for the response may cause concurrency problems           */
  /* so we wrapped the function and limited the maximum number of concurrent calls to 1 with bottlenck library */  
  async command(command) {
    return await this.limiter.schedule(() => this.command_wrapped(command));        
  }  
  async command_wrapped(cmd) {
    await this.write( new TextEncoder().encode(cmd) );

    var i=0;
    var uint8array;
    do {
      await sleep(100);
      uint8array = new Uint8Array( await this.read(31) );
      i++;
      if (i>10) throw new Error("timeout");

      /* Pending – the request is still being processed.  Ensure that you have waited the minimum time to guarantee a response */
    } while (uint8array[0]==254);

    switch (uint8array[0]) {
      case 255: /*No Data – there is no pending request, so there is no data to return from the circuit */
        return(undefined);
      case   2: /* Failed – the request failed */
        throw new Error("Syntax error");
      case   1: /* Success – the requested information is ready */
        uint8array = uint8array.subarray(1);
        uint8array = uint8array.map(v => v &= ~0x80);
        uint8array = uint8array.filter(v => v != 0);
        return( String.fromCharCode.apply(null, uint8array) );
      default:
        throw new Error("Device error");
    }
  }
}

EZO_I2C.constuctor();

export default EZO_I2C;